import { render } from "./UpcomingEvents.vue?vue&type=template&id=1cc9d684"
import script from "./UpcomingEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingEvents.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/sarahmarinoff/Sites/fc2025/wp-content/plugins/baytek-portal-helper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/UpcomingEvents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cc9d684"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cc9d684', __exports__)) {
    console.log('reload')
    api.reload('1cc9d684', __exports__)
  }
  
  module.hot.accept("./UpcomingEvents.vue?vue&type=template&id=1cc9d684", () => {
    console.log('re-render')
    api.rerender('1cc9d684', render)
  })

}


export default __exports__